

export const MESSAGE_CREATE  = 'MESSAGE_CREATE'; 
export const MESSAGE_FETCH   = 'MESSAGE_FETCH'; 
export const MESSAGE_SUCCESS = 'MESSAGE_SUCCESS'; 
export const MESSAGE_UPDATE  = 'MESSAGE_UPDATE';
export const MESSAGE_TOGGLE  = 'MESSAGE_TOGGLE'; //toggle by PID
export const MESSAGE_ERROR   = 'MESSAGE_ERROR';